import { render, staticRenderFns } from "./AdminToolMenu.vue?vue&type=template&id=051afab2&scoped=true"
import script from "./AdminToolMenu.vue?vue&type=script&lang=ts"
export * from "./AdminToolMenu.vue?vue&type=script&lang=ts"
import style0 from "./AdminToolMenu.vue?vue&type=style&index=0&id=051afab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051afab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VContainer,VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
